'use client';

import * as React from 'react';

/* Stable id generator for ARIA labelling. Thin wrapper over React.useId
   so the kit's generated id matches whatever React's reconciler picks
   across renders and Suspense boundaries.

   React 18 emits ids shaped like ":r0:" — colons are valid HTML id
   characters per the spec, but they're awkward to target with
   querySelector (need CSS.escape) and trip some older CSS engines.
   Strip the colons specifically rather than a broad
   /[^\w-]/g — the latter would silently swallow any new character
   React's reconciler emits in a future major and hide the bug
   rather than surface it. */
export function useStableId(prefix: string): string {
  const id = React.useId();
  return `${prefix}-${id.replaceAll(':', '')}`;
}
